<template>

</template>

<script>
  import wx from 'weixin-jsapi'

  export default {
    name: 'share',
    data() {
      return {
        shareLink: process.env.DOMAIN_NAME+"goods/details?hid="+this.$store.state.hid
      }
    },
    created () {
      //let shareLinkUlr = location.href.split("#")[0]; // 获取当前的url 去掉 # 之后的部分
      //shareLinkUlr = shareLinkUlr.replace(/\&/g, '%26'); // 将 & 替换成 %26
      let shareLink = window.location.href
      this.getJssdkConfig("onMenuShareTimeline,checkJsApi,onMenuShareAppMessage",false,false,shareLink);
    },
    methods: {
      getJssdkConfig(apis,debug,json,link){
        let self = this
        this.$api.get('jssdkConfig', {apis:apis, debug:debug, json:json, url: link}, r=>{
          let config = JSON.parse(r.data)
          wx.config(config)
          wx.ready(function() {
            var shareData = {
              title: '沃隆多肽倍护精华液套盒',
              desc: '秀发健康需要养，靓丽自信从头来，行动就拥有',
              link: self.shareLink,
              imgUrl: 'https://xy.itxwzj.com/statics/wap/images/1.jpg',
              success: function () {
                //$.get('/shareHits/'+$("#act_id").val(),{},function(){});
              }
            }
            wx.showOptionMenu()
            wx.onMenuShareAppMessage(shareData)
            wx.onMenuShareTimeline(shareData)
          })
          wx.error(function(error){
            //console.log(error)
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wxjsapi/share.vue